<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">Enroll in PSP</h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHTML]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a [routerLink]="['/driver/1']" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="3" [totalSteps]="19"></app-complete-bar>
                              <h2>
                                   {{ enrollmentService.newCustomer!.customerType === customerType.AH ?
                                   getTranslator('MAHHeader') : getTranslator('ISP46_10') }}
                              </h2>
                              <p [innerHTML]="'CompanyName_1' | translator:'base'">Next, let's gather information about
                                   your company.</p>
                              <hr />
                              <div class="mb-3" [formGroup]="companyInfo">
                                   <label class="form-label" for="OrganizationName">
                                        <span [innerHTML]="'CompanyName_2' | translator:'base'">What's your company's name?</span>
                                        <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <input 
                                        type="text" 
                                        formControlName="name" 
                                        maxlength="100"
                                        id="OrganizationName" 
                                        name="OrganizationName" 
                                        class="bg-light form-control"
                                        />
                                   <div *ngIf="name!.invalid && name!.dirty"
                                        class="help-block text-danger">
                                        <div *ngIf="name!.errors?.['required']"
                                             [innerHTML]="'CompanyName_required' | translator:'base'">
                                        </div>
                                        <div *ngIf="name!.errors?.['maxlength']"
                                             [innerHTML]="'max' | translator:'base'">
                                        </div>
                                        <div *ngIf="name!.errors?.['pattern']"
                                             [innerHTML]="'CompanyName_invalid' | translator:'base'">
                                        </div>
                                   </div>
                              </div>
                              <div [formGroup]="companyInfo">
                                   <label class="form-label" for="OrganizationCountry">
                                        <span [innerHTML]="'CompanyName_4' | translator:'base'">In what country is your
                                             company located?</span>
                                        <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                                   </label>
                                   <select formControlName="country" (change)="countryChanged()" id="OrganizationCountry" name="OrganizationCountry"
                                        class="bg-light form-select">
                                        <option value=""></option>
                                        <option *ngFor="let c of countriesList" [value]="c">{{ getTranslator(c) }}
                                        </option>
                                   </select>
                                   <div *ngIf="country!.invalid && country!.dirty"
                                        class="help-block text-danger">
                                        <div *ngIf="country!.errors?.['required']"
                                             [innerHTML]="'CompanyName_5' | translator:'base'">
                                             Country is required.
                                        </div>
                                        <div *ngIf="country!.errors?.['pattern']"
                                             [innerHTML]="'CompanyName_6' | translator:'base'">
                                             If your company address is in Mexico, please call PSP help at <a href="tel:877-642-9499"
                                                target='_new'
                                                title="1-877-642-9499"
                                                name="1-877-642-9499">1-877-642-9499</a> or email us at <a href="mailto:PSPhelp@tylertech.com"
                                                target='_new'
                                                title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a>.
                                        </div>
                                   </div>
                              </div>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group"
                                        role="group">
                                        <button [routerLink]="'/signup/6'"
                                                [disabled]="isDisabled()"
                                                tag="button"
                                                class="btn btn-primary btn-strong"
                                                (click)="scrollToTop()"
                                                name="companyNext5"
                                                id="companyNext5"
                                                [title]="'CompanyInfo' | translator:'base'">
                                             <span [innerHTML]="'Continue' | translator:'base'"></span>
                                             <span class="sr-only">&nbsp;{{
                                                  enrollmentService.newCustomer!.customerType === customerType.AH ?
                                                  getTranslator('MAHInfo') : getTranslator('ISPInfo')
                                                  }}
                                             </span>
                                        </button>
                                   </div>

                                   <div class="btn-group" role="group">
                                        <button
                                             [routerLink]="enrollmentService.newCustomer!.customerType === customerType.AH ? '/signup/2' : '/signup/3'"
                                             class="btn btn-outline-primary" (click)="scrollToTop()"
                                             [title]="'BackToWelcome' | translator:'base'" name="companyBack5"
                                             id="companyBack5">
                                             <span [innerHTML]="'Back' | translator:'base'"></span>
                                             <span class="sr-only"
                                                  [innerHTML]="'GSMAH_Back to' | translator:'base'">Welcome</span>
                                        </button>
                                        <a [routerLink]="'/'" tag="button" class="btn btn-light" (click)="scrollToTop()"
                                             name="companyCancel5" id="companyCancel5"
                                             [innerHTML]="'Cancel' | translator:'base'"
                                             [title]="'Cancel' | translator:'base'">Cancel</a>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
</div>

